import { Student } from "@axl/membership-sdk";
import { useContext, useEffect, useState } from "react";

import { SdkContext } from "../../providers/SdkProvider";

export const useUser = () => {
  const { sdk } = useContext(SdkContext);
  const [user, setUser] = useState<Student | null>(sdk.account.user);

  useEffect(() => {
    const handler = () => {
      const newUser = sdk.account.user;
      setUser((prev) => {
        if (
          (prev === null && newUser === null) ||
          (prev && newUser && JSON.stringify(prev) === JSON.stringify(newUser))
        ) {
          return prev;
        }

        return newUser;
      });
    };

    sdk.dispatcher.on("auth.user.changed", handler);

    return () => {
      sdk.dispatcher.off("auth.user.changed", handler);
    };
  }, [sdk]);

  return {
    ...sdk.account,
    isAuthorized: sdk.account.isAuthorized,
    user,
  };
};
